import KFStandard from "../../KFDetail/KFStandard/KFStandard.vue";
import FinanzierugMixin from "../Mixins/FinanzierugMixin";

// @vue/component
export default {
  name: "StandardFinanzierung",
  components: {
    KFStandard,
  },
  mixins: [
    FinanzierugMixin,
  ],
  computed: {
    sumLocal() {
      return this.antragBetragCurrency;
    },
  },
};
